export default __webpack_public_path__ + "static/media/15091@2x.56aeab48.png";